import Rellax from 'rellax';

const settings = {
    wrapper: '.content',
    parallaxSelector: '[js-parallax]'
}
if(document.querySelector(settings.parallaxSelector)){
    const rellax = new Rellax(settings.parallaxSelector, {
        wrapper: settings.wrapper,
        center:true
    });
}

